import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  convertStringToArray,
  extractDateFromStr,
  getLatestUpdatedObject,
  sanitizeString,
} from "../../../Utils/utils";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import usePagination from "../../../hooks/usePagination";
import Pagination from "../../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { imageUrl } from "../../../constants/constants";

const LatestNewsPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const {
    data: latestNewsData = [],
    error: latestNewsError,
    isLoading: latestNewsIsLoading,
  } = useGetProtectedApiDataQuery({ url: "latest_news", lang: languageType });
  const navigate = useNavigate();

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(latestNewsData)?.changed);
  }, [latestNewsData]);

  const transformedData = useMemo(() => {
    return latestNewsData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [latestNewsData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(transformedData, 10);

  const handlePhotoClick = (nid) => {
    navigate(`/latest-news-detail/${nid}`);
  };
  if (latestNewsIsLoading) {
    return <Loader />;
  }
  if (latestNewsError) {
    return <div>Failed to load news. Please try again later.</div>;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Latest News", "नवीनतम समाचार")}
        titleLink="/latest-news-detail"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Latest News", "नवीनतम समाचार")}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany latest-news">
            <div className="container1">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              <div className="row mb-5">
                {currentItems.map((item, index) => {
                  const title = sanitizeString(item.title);
                  const desc = sanitizeString(item.body);
                  return (
                    <div
                      className="col-12 col-sm-12 col-md-6 col-lg-6"
                      key={index}
                    >
                      <div
                        className="card-sec wow zoomIn"
                        onClick={() => handlePhotoClick(item.nid)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="img-sec">
                          <img
                            alt={title}
                            src={
                              item?.field_upload_image?.[0]?.file_path
                                ? imageUrl +
                                  item.field_upload_image[0].file_path
                                : "images/dummy.png"
                            }
                          />
                        </div>
                        <div className="desc-sec">
                          {item?.field_ordering_date && (
                            <span className="date">
                              {item?.field_ordering_date}
                            </span>
                          )}

                          <a
                            href="#"
                            role="button"
                            tabIndex={0}
                            onClick={(e) => e.preventDefault()}
                            className="line-clamp line-clamp-1"
                          >
                            {title}
                          </a>
                          <p className="line-clamp line-clamp-5">{desc}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Pagination */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </section>
        </div>
      </div>
    </>
  );
};

export default LatestNewsPage;
